import { render, staticRenderFns } from "./schemeManage.vue?vue&type=template&id=1e3e16ce&scoped=true&"
import script from "./schemeManage.vue?vue&type=script&lang=ts&"
export * from "./schemeManage.vue?vue&type=script&lang=ts&"
import style0 from "./schemeManage.vue?vue&type=style&index=0&id=1e3e16ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e16ce",
  null
  
)

export default component.exports